'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var styleHelper = require('../../helper/styleHelper');
var appTypes = require('../../types/appTypes');
var Border = require('../common/Border');
var textHelper = require('../../helper/util').Text;
var measureHelper = require('../../helper/measureHelper');

var Item = React.createClass({
  propTypes: {
    parentStyle: React.PropTypes.object.isRequired, // 父级的样式，这里测量文字时需要用到
    width: React.PropTypes.number.isRequired,
    tabHeight: React.PropTypes.number.isRequired,
    fontSize: React.PropTypes.number.isRequired
  },
  render: function () {
    var parentStyle = this.props.parentStyle;
    var fontSize = this.props.fontSize;
    var halfFontSize = fontSize / 2;
    var tabHeight = parseInt(this.props.tabHeight, 10);
    var css = {
      height: this.props.height,
      backgroundColor: this.props.backgroundColor || '#ddd',
      borderLeftColor: this.props.hideLeftBorder ? this.props.backgroundColor : this.props.borderColor,
      borderRightColor: this.props.hideRightBorder ? this.props.backgroundColor : this.props.borderColor,
      padding: 0
    };

    if (this.props.direction == 'HdLeft') {
      css.borderTopLeftRadius = this.props.radius;
      css.borderBottomLeftRadius = this.props.radius;
      css.borderLeftColor = this.props.borderColor;
      css.borderTopColor = this.props.borderColor;
      css.borderBottomColor = this.props.borderColor;
    } else {
      css.borderTopRightRadius = this.props.radius;
      css.borderBottomRightRadius = this.props.radius;
      css.borderRightColor = this.props.borderColor;
      css.borderTopColor = this.props.borderColor;
      css.borderBottomColor = this.props.borderColor;
    }

    var labelCss = {
      display: 'block',
      height: fontSize,
      lineHeight: fontSize + 'px'
    };
    var itemContentCss = {
      width: 0,
      height: 0,
      margin: 0,
      position: 'relative',
      padding: 0,
      display: 'inline-block'
    };
    var texts = this.props.text.split('\\r');

    var maxText = '';
    texts.forEach(function (item) {
      var measuredSize = measureHelper.measureTextWidth(parentStyle, item);
      if (item.length > maxText) {
        maxText = item;
        itemContentCss.width = measuredSize.width;
      }
      itemContentCss.height += measuredSize.height;
    });

    if (this.props.tabDirection === 'SmVert') { // 垂直选项卡
      css.width = this.props.tabHeight;
      css.height = itemContentCss.width + 16;
      labelCss.display = 'block';
      labelCss.position = 'relative';
      css.textAlign = 'left';
      itemContentCss.transformOrigin = '0 0';
      var xTranslate, yTranslate;
      if (this.props.direction === 'HdLeft') { // 左侧
        xTranslate = -(itemContentCss.width + css.height) / 2 + 'px';
        yTranslate = '-50%';
        itemContentCss.transform = 'rotate(-90deg) translate(' + xTranslate + ', ' + yTranslate + ')';
        itemContentCss.left = '50%';
      } else { // 右侧
        xTranslate = itemContentCss.height / 2 - halfFontSize + 'px';
        yTranslate = -(halfFontSize + tabHeight / 2) + 'px';
        itemContentCss.transform = 'rotate(90deg) translate(' + xTranslate + ', ' + yTranslate + ')';
      }
    } else { // 水平选项卡以及原来的老版本兼容
      css.textAlign = 'center';
      css.lineHeight = tabHeight + 'px';
      css.width = this.props.width + 16;
    }

    delete itemContentCss.width;
    delete itemContentCss.height;

    return (
      <div className="item" style={css} onClick={this._onSelfClick}>
        <div className="item-content" style={itemContentCss}>
          {texts.map(function (text, idx) {
            return <label key={idx} style={labelCss}>{text}</label>;
          })}
        </div>
      </div>
    );
  },

  _onSelfClick: function (e) {
    if (this.props.onClick) {
      this.props.onClick(e, this.props.index);
    }
  }
});

var VerticalTabBar = React.createClass({
  propTypes: {
    text: React.PropTypes.string.isRequired
  },

  getInitialState: function () {
    return {
      selectedIndex: parseInt(this.props.selectedIndex, 10)
    };
  },

  parseText: function () {
    return textHelper.delimitText(styleHelper.getText(this.props), textHelper.DM_COMMA);
  },

  render: function () {
    var textItems = this.parseText();
    this.showScrollBar = false;
    var tabHeight = parseInt(this.props.tabHeight, 10);
    var value = 0;
    var isLeft = this.props.direction === appTypes.HorizontalDirection.LEFT;
    var selIndex = this.state.selectedIndex;
    var tabColor = this.props.tabColor;
    var h = styleHelper.getHeight(this.props);
    var bg = styleHelper.getBackgroundColor(this.props);

    if (!_.isUndefined(this.props.verticalScrollbarShow)) {
      this.showScrollBar = this.props.verticalScrollbarShow;
      value = parseInt(this.props.verticalScrollbarProgress, 10);
    }

    var style = {
      whiteSpace: 'nowrap',
      textAlign: 'center',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%'
    };

    styleHelper.builderTextStyle(this.props, style);

    var cssBar = {
      height: h - 20,
      top: this.props.tabEdge
    };

    var barWidth = this.getBarWidth();

    if (this.isTabAtLeft()) {
      return (<div className='component component-verticalTabBar bar-at-left' style={style}>
        <div ref="bar"
             className="bar"
             style={cssBar}
        >{textItems.map(function (item, index) {
          return (<Item
            key={index}
            index={index}
            hideLeftBorder={!isLeft && (index === selIndex)}
            hideRightBorder={isLeft && (index === selIndex)}
            text={item}
            height={tabHeight}
            backgroundColor={index === selIndex ? bg : tabColor}
            onClick={this.onSelected.bind(this, index)}
            direction={this.props.direction}
            tabDirection={this.props.tabDirection}
            radius={this.props.radius}
            borderColor={this.props.borderColor}
            tabEdge={this.props.tabEdge}
            tabHeight={tabHeight}
            fontSize={parseInt(this.props.textSize, 10)}
            parentStyle={style}
            width={barWidth}
          />);
        }, this)
        }
        </div>
        <div ref="content" className="content" style={this.contentCSS(isLeft)}>
          {
            this.showScrollBar && (<VerticalScrollBar ref="scroll" {...{
              value: value,
              right: 0,
              height: '100%',
              zIndex: 1
            }}/>)
          }
        </div>
      </div>)
    }

    return (<div className='component component-verticalTabBar bar-at-right' style={style}>
      <div ref="content" className="content" style={this.contentCSS(isLeft)}>
        {
          this.showScrollBar && (<VerticalScrollBar ref="scroll" {...{
            value: value,
            right: 0,
            height: '100%',
            zIndex: 1
          }}/>)
        }
      </div>
      <div ref="bar"
           className="bar"
           style={cssBar}
      >{textItems.map(function (item, index) {
        return (<Item
          key={index}
          index={index}
          hideLeftBorder={!isLeft && (index === selIndex)}
          hideRightBorder={isLeft && (index === selIndex)}
          text={item}
          height={tabHeight}
          backgroundColor={index === selIndex ? bg : tabColor}
          onClick={this.onSelected.bind(this, index)}
          direction={this.props.direction}
          tabDirection={this.props.tabDirection}
          radius={this.props.radius}
          borderColor={this.props.borderColor}
          tabEdge={this.props.tabEdge}
          tabHeight={tabHeight}
          fontSize={parseInt(this.props.textSize, 10)}
          parentStyle={style}
          width={barWidth}
        />);
      }, this)
      }
      </div>
    </div>)
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onSelected);
  },

  isTabAtLeft: function () {
    return this.props.direction === appTypes.HorizontalDirection.LEFT;
  },

  contentCSS: function (isLeft) {
    var showBorder = this.props.borderVisible;

    return {
      backgroundColor: styleHelper.getBackgroundColor(this.props),
      borderTopStyle: showBorder ? 'solid' : 'none',
      borderBottomStyle: showBorder ? 'solid' : 'none',
      borderLeftStyle: isLeft ? 'solid' : ( showBorder ? 'solid' : 'none'),
      borderRightStyle: !isLeft ? 'solid' : (showBorder ? 'solid' : 'none'),
      position: 'relative'
    }
  },

  onSelected: function (index) {
    this.setState({
      selectedIndex: index
    })
  },

  /**
   * 获取选项卡的宽度
   * @returns {number}
   */
  getBarWidth: function () {
    var textItems = this.parseText();
    var maxWidth = 0;
    var style = {};
    styleHelper.builderTextStyle(this.props, style);
    textItems.forEach(function (item) {
      item && item.split('\\r').forEach(function (line) {
        var width = measureHelper.measureTextWidth(style, line).width;
        if (width > maxWidth) {
          maxWidth = width;
        }
      });
    });
    return maxWidth;
  }
});

module.exports = VerticalTabBar;



// WEBPACK FOOTER //
// ./src/views/Components/VerticalTabBar.jsx